import * as SentryAngular from '@sentry/angular'
import { APP_INITIALIZER, ErrorHandler } from '@angular/core'
import { Router } from '@angular/router'

export const sentryProviders = [
  {
    provide: ErrorHandler,
    useValue: SentryAngular.createErrorHandler({
      showDialog: false,
    }),
  },
  {
    provide: SentryAngular.TraceService,
    deps: [Router],
  },
  {
    provide: APP_INITIALIZER,
    useFactory: () => () => {},
    deps: [SentryAngular.TraceService],
    multi: true,
  },
]
